const TYPES = {
  AGENCY: 'agency_user',
  LOCATION: 'location_user',
  SUBSCRIBER: 'subscriber',
  SUPER_ADMIN: 'super_admin',
}

const ROLES = {
  SUPER_ADMIN: 'super_admin',
  OPERATOR: 'operator',
  CONSUMER: 'consumer',
  SUPPORT: 'support',
}

export { TYPES, ROLES }
